export const PERMISSION_MAPPINGS = {
  "User Management": {
    0: "UserModelCreate",
    1: "UserModelUpdate",
    2: "UserModelRead",
    3: "UserModelDelete",
  },
  "Role Management": {
    0: "RoleModelCreate",
    1: "RoleModelUpdate",
    2: "RoleModelRead",
    3: "RoleModelDelete",
    4: "AssignRoleModelCreate",
    5: "AssignRoleModelUpdate",
    6: "AssignRoleModelRead",
    7: "AssignRoleModelDelete",
  },
  "Organization & Account": {
    0: "OrganizationModelCreate",
    1: "OrganizationModelUpdate",
    2: "OrganizationModelRead",
    3: "OrganizationModelDelete",
    4: "AccountModelCreate",
    5: "AccountModelUpdate",
    6: "AccountModelRead",
    7: "AccountModelDelete",
  },
  "Authentication & Security": {
    0: "AuthenticatorModelCreate",
    1: "AuthenticatorModelUpdate",
    2: "AuthenticatorModelRead",
    3: "AuthenticatorModelDelete",
    4: "OTPModelCreate",
    5: "OTPModelUpdate",
    6: "OTPModelRead",
    7: "OTPModelDelete",
    8: "RecoveryQuestionModelCreate",
    9: "RecoveryQuestionModelUpdate",
    10: "RecoveryQuestionModelRead",
    11: "RecoveryQuestionModelDelete",
  },
  "Event Management": {
    0: "EventModelCreate",
    1: "EventModelUpdate",
    2: "EventModelRead",
    3: "EventModelDelete",
    4: "SubEventModelCreate",
    5: "SubEventModelUpdate",
    6: "SubEventModelRead",
    7: "SubEventModelDelete",
    8: "TownhallModelCreate",
    9: "TownhallModelUpdate",
    10: "TownhallModelRead",
    11: "TownhallModelDelete",
  },
  "Financial Management": {
    0: "ExpenseModelCreate",
    1: "ExpenseModelUpdate",
    2: "ExpenseModelRead",
    3: "ExpenseModelDelete",
    4: "CampaignFundsModelCreate",
    5: "CampaignFundsModelUpdate",
    6: "CampaignFundsModelRead",
    7: "CampaignFundsModelDelete",
    8: "DonationModelCreate",
    9: "DonationModelUpdate",
    10: "DonationModelRead",
    11: "DonationModelDelete",
  },
  "Communication & Media": {
    0: "SurveyPollsModelCreate",
    1: "SurveyPollsModelUpdate",
    2: "SurveyPollsModelRead",
    3: "SurveyPollsModelDelete",
    4: "MediaModelCreate",
    5: "MediaModelUpdate",
    6: "MediaModelRead",
    7: "MediaModelDelete",
  },
  "Support & Content": {
    0: "SupportTicketModelCreate",
    1: "SupportTicketModelUpdate",
    2: "SupportTicketModelRead",
    3: "SupportTicketModelDelete",
    4: "FaqModelCreate",
    5: "FaqModelUpdate",
    6: "FaqModelRead",
    7: "FaqModelDelete",
  },
  "Candidate & Campaign": {
    0: "CandidateModelCreate",
    1: "CandidateModelUpdate",
    2: "CandidateModelRead",
    3: "CandidateModelDelete",
    4: "ManifestoModelCreate",
    5: "ManifestoModelUpdate",
    6: "ManifestoModelRead",
    7: "ManifestoModelDelete",
  },
  Canvass: {
    0: "CanvassModelCreate",
    1: "CanvassModelUpdate",
    2: "CanvassModelRead",
    3: "CanvassModelDelete",
  },
  "System & Logs": {
    0: "ActivityLogModelCreate",
    1: "ActivityLogModelUpdate",
    2: "ActivityLogModelRead",
    3: "ActivityLogModelDelete",
  },
};

export const mapSelectedStatesToPermissions = (selectedStates, category) => {
  const categoryMap = PERMISSION_MAPPINGS[category] || {};
  return Object.entries(selectedStates)
    .filter(([, isSelected]) => isSelected)
    .map(([index]) => categoryMap[index])
    .filter(Boolean);
};

